import { gql, useQuery } from '@apollo/client'
import { currentMarketIdVar } from 'graphql/reactive'

export const POTENTIAL_PROFILE_FRAGMENT = gql`
  fragment fullPublicPotentialProfile on PublicPotentialProfile {
    id
    name
    slug
    title
    description
    profilePicture {
      id
      avatarUrl: url(
        format: { width: 100, height: 100, fit: crop, mask: ellipse }
      )
      bigUrl: url(format: { width: 400, height: 740, fit: crop })
      cardUrl: url(format: { width: 265, height: 458, fit: crop })
      meanBackgroundColorHex
    }
  }
`

export const GET_PUBLIC_POTENTIAL_PROFILE = gql`
  query GetPublicPotentialProfile($marketId: ID!, $slug: String!) {
    market(id: $marketId) {
      id
      potentialProfile(slug: $slug) {
        ...fullPublicPotentialProfile
      }
    }
  }
  ${POTENTIAL_PROFILE_FRAGMENT}
`

export default function usePublicPotentialProfile(slug, useQueryParams = {}) {
  const marketId = currentMarketIdVar()

  const {
    loading,
    data = {},
    networkStatus,
    error,
  } = useQuery(GET_PUBLIC_POTENTIAL_PROFILE, {
    variables: { slug, marketId },
    ...useQueryParams,
    returnPartialData: true,
  })

  const potentialProfile = data.market?.potentialProfile

  return {
    potentialProfile,
    loading,
    error,
    networkStatus,
  }
}
